import urlToId from './converters/urlToId';

const isValidVehicle =
  ({
    route,
    pallets,
    weight,
    height,
    needs_liftgate,
    needs_lateral_loading,
    needs_top_load,
    carrier,
  }) =>
  (vehicle) => {
    const routes =
      (vehicle.carrier &&
        (vehicle.carrier.routes || []).map(
          ({ origin, destination }) => `${origin}-${destination}`
        )) ||
      [];

    return (
      (!carrier ||
        (typeof vehicle.carrier === 'string' &&
          String(urlToId(vehicle.carrier)) === String(carrier)) ||
        (vehicle.carrier && String(urlToId(vehicle.carrier.url)) === String(carrier))) &&
      (!route || route === 'any' || routes.indexOf(route) >= 0) &&
      (!pallets || pallets <= (vehicle.max_pallets || 0)) &&
      (!weight || weight <= Number(vehicle.max_weight || 0)) &&
      (!height || height <= Number(vehicle.container_height || 0)) &&
      (!needs_liftgate || vehicle.has_liftgate) &&
      (!needs_lateral_loading || vehicle.has_lateral_loading) &&
      (!needs_top_load || vehicle.has_superior_loading) &&
      ((vehicle.carrier && vehicle.carrier.is_active) ||
        (!vehicle.carrier && vehicle.carrier_is_active))
    );
  };

export const isValidVehicleForJourney = (journey) => (vehicle) => {
  return (
    vehicle &&
    isValidVehicle({
      pallets: journey.max_equivalent_pallets,
      weight: journey.max_weight,
      height: journey.item_height / 100,
      needs_liftgate: (journey.extras || []).indexOf('LIFTGATE') >= 0,
      needs_lateral_loading: (journey.extras || []).indexOf('SIDE_LOAD') >= 0,
      temperature_ranges: journey.temperature_ranges,
      temperature_chambers: (journey.temperature_ranges || []).length,
    })(vehicle)
  );
};
